var _path, _circle, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAttractions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1804_92000)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5217 37.3066C19.7353 33.3885 23.6516 30.7559 26.9359 27.6794C30.0525 24.7599 32 20.6074 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 20.6074 1.94745 24.7599 5.06412 27.6794C8.34841 30.7559 12.2647 33.3885 14.4783 37.3066L15.5647 39.2295C15.7561 39.5682 16.2439 39.5682 16.4353 39.2295L17.5217 37.3066Z",
    fill: "#4B4B4B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6991 8.84148C18.9168 7.58112 17.0828 7.58114 16.3005 8.84152L9.09838 20.4453C8.27145 21.7776 9.2296 23.5 10.7977 23.5H25.2024C26.7705 23.5 27.7286 21.7776 26.9016 20.4453L19.6991 8.84148ZM23.6506 19L25.2024 21.5H10.7977L17.9998 9.89623L22.4092 17H20C19.4477 17 19 17.4477 19 18C19 18.5523 19.4477 19 20 19H23.6506Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1804_92000",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 7,
    width: 23,
    height: 17
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6993 8.8415C18.917 7.58113 17.0831 7.58113 16.3008 8.8415L14.9431 11.0289L13.6435 9.7293C12.9692 9.05494 11.845 9.17286 11.3252 9.97248L5.66364 18.6825C5.01501 19.6804 5.73114 21 6.9213 21L8.85848 21C8.54081 22.2105 9.44094 23.5 10.7977 23.5H25.2024C26.7705 23.5 27.7286 21.7776 26.9017 20.4453L19.6993 8.8415ZM9.99549 19H7.84264L12.6657 11.5799L13.8599 12.7741L9.99549 19ZM25.2024 21.5L23.6507 19H20C19.4477 19 19 18.5523 19 18C19 17.4477 19.4477 17 20 17H22.4093L21.7886 16H14.2115L10.7977 21.5L9.99216 21L10.7977 21.5H25.2024ZM15.4529 14H20.5472L18 9.89622L15.4529 14Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1804_92000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#4B4B4B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1804_92000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 39.4835,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttractions);
export default __webpack_public_path__ + "static/media/icon_attractions.ad11ca2bf7a305438d797620b93d55ca.svg";
export { ForwardRef as ReactComponent };